<ion-content>
  <app-callcard-detail-info [callcard]="callcard"></app-callcard-detail-info>

  <app-callcard-detail-card
    *ngFor="let component of customContent"
    [component]="component"
    [callcard]="callcard"
  ></app-callcard-detail-card>

  <app-callcard-cpatients-card [callcard]="callcard"></app-callcard-cpatients-card>
  <app-callcard-ccallers-card [callcard]="callcard"></app-callcard-ccallers-card>

  <app-callcard-detail-collapsible [callcard]="callcard"></app-callcard-detail-collapsible>

  <app-callcard-media-buttons [callcard]="callcard"></app-callcard-media-buttons>

  <app-callcard-detail-buttons-v [card]="callcard"></app-callcard-detail-buttons-v>
</ion-content>
